import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const greetingLinesAsScenesSceneBackground = {
    variant: "plain-color",
    color: "rgba(255, 254, 242, 0.82)",
    // softens the edges of the background to make the transition less harsh
    blur: 50,
};
const sceneTransition = {
    variant: "slide-fade",
    direction: "from-right",
    timing: {
        variant: "linear",
        easing: "easeOut",
        durationSeconds: 1.8,
    },
};
const images = {
    bird_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/bird_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/optimized/bird_1.webp`,
        width: 50,
        height: 31,
    },
    bird_2: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/bird_2.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/optimized/bird_2.webp`,
        width: 43,
        height: 38,
    },
    fog_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/fog_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/optimized/fog_1.webp`,
        width: 1919,
        height: 629,
    },
    mountains_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/mountains_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/optimized/mountains_1.webp`,
        width: 1920,
        height: 810,
    },
    trees_1: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/trees_1.webp`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/mountain-view/optimized/trees_1.webp`,
        width: 1920,
        height: 633,
    },
};
export const mountainView = {
    version: 1,
    themeId: "mountain-view",
    name: "Mountain View",
    endFadeDuration: 1,
    thumbnailFrame: 150,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/mountain-view.webp`,
    background: [
        {
            variant: "meadow-flowers",
            color: "#e0e5dc",
            images: [
                {
                    src: images["mountains_1"],
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                            position: {
                                x: {
                                    from: "left",
                                    offset: 0,
                                },
                                y: {
                                    from: "top",
                                    offset: 100,
                                },
                            },
                        },
                        end: {
                            frame: 60,
                            opacity: 1,
                        },
                    },
                    repeat: "repeat-x",
                    movePerSecond: {
                        x: -30,
                        y: 0,
                    },
                },
                {
                    src: images["fog_1"],
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                            position: {
                                x: {
                                    from: "left",
                                    offset: 0,
                                },
                                y: {
                                    from: "bottom",
                                    offset: 100,
                                },
                            },
                        },
                        end: {
                            frame: 60,
                            opacity: 1,
                        },
                    },
                    repeat: "repeat-x",
                    movePerSecond: {
                        x: -50,
                        y: 0,
                    },
                },
                {
                    src: images["trees_1"],
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                            position: {
                                x: {
                                    from: "left",
                                    offset: 0,
                                },
                                y: {
                                    from: "bottom",
                                    offset: 100,
                                },
                            },
                        },
                        end: {
                            frame: 60,
                            opacity: 1,
                        },
                    },
                    repeat: "repeat-x",
                    movePerSecond: {
                        x: -60,
                        y: 0,
                    },
                },
            ],
            bees: [
                {
                    src: images["bird_1"],
                    sizeScale: 1,
                    movementScale: 0.5,
                    positionPercent: {
                        x: 2,
                        y: 2,
                    },
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                        },
                        end: {
                            frame: 60,
                        },
                    },
                },
                {
                    src: images["bird_2"],
                    sizeScale: 1,
                    movementScale: 0.5,
                    positionPercent: {
                        x: 10,
                        y: 40,
                    },
                    enter: {
                        start: {
                            frame: 5,
                            blur: 10,
                            opacity: 0,
                        },
                        end: {
                            frame: 60,
                        },
                    },
                },
            ],
        },
    ],
    scenes: [
        {
            type: "mountainViewIntro",
            durationSeconds: 9,
            secondsPerCharacter: 0.1,
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                borderWidth: 14,
                entrance: {
                    variant: "fade-in",
                    transitionDurationInFrames: 160,
                    // TODO -- this is a quick, working fix but makes it easy for the title
                    // to overlap the face collage and isn't spaced like in the design.
                    bottomStyle: {
                        paddingBottom: "60px",
                    },
                },
            },
            title: {
                fontFamily: "Cutive Mono",
                fontSize: 140,
                fontWeight: "normal",
                textColor: "#293435",
                leading: 1.08,
                textAlign: "center",
                backgroundColor: "#ece5b4d0",
            },
            subtitle: {
                fontFamily: "Cutive Mono",
                fontSize: 70,
                fontWeight: "light",
                textColor: "#293435",
                textTransform: "uppercase",
                textAlign: "center",
            },
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            showLogo: true,
            sceneBackground: greetingLinesAsScenesSceneBackground,
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: greetingLinesAsScenesSceneBackground,
        },
        {
            type: "outro",
            colorVariant: "darkBlue",
            background: {
                variant: "slanted-catchup",
                backgroundColor: "#ece5b4d0",
                durationSeconds: 0.5,
                delaySeconds: 1.2,
            },
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#cb6a59",
            fontFamily: "Cutive Mono",
            fontWeight: "light",
            fontSize: 90,
            leading: 1.2,
            tracking: 0,
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                startOffsetSeconds: 0.6,
                cards: [
                    {
                        backgroundColor: "#e0e5dc",
                        backgroundOpacity: 1,
                        paddingLeft: "7rem",
                        paddingRight: "4rem",
                        backgroundImages: [
                            {
                                url: images["mountains_1"],
                                style: {
                                    opacity: 0.3,
                                    backgroundSize: "auto 85%",
                                    backgroundPosition: "bottom",
                                    backgroundRepeat: "repeat-x",
                                },
                            },
                            {
                                url: images["trees_1"],
                                style: {
                                    opacity: 0.3,
                                    backgroundSize: "auto 70%",
                                    backgroundPosition: "bottom",
                                    backgroundRepeat: "repeat-x",
                                },
                            },
                        ],
                    },
                ],
            },
            betweenTransition: sceneTransition,
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#cb6a59",
                fontFamily: "Cutive Mono",
                fontWeight: "normal",
                fontSize: 70,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#cb6a59",
                fontFamily: "Cutive Mono",
                fontWeight: "normal",
                fontSize: 40,
                nudge: 2,
                textTransform: "uppercase",
            },
            scaleFactor: 0.9,
            borderRadius: "3rem",
            boxShadow: "0.25rem 0.25rem 1.125rem 0px rgba(0,0,0,0.75)",
            border: "0.25rem solid #232626",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition,
    },
    userInputFields: [
        {
            id: "titleMessage",
            type: "text",
            label: "Title Message",
            defaultValue: "",
            placeholder: "Wishing you all the best!",
            required: true,
            min: 1,
            max: 25,
            preview: {
                sceneIndex: 0,
                frameOffset: 200,
            },
        },
        {
            id: "subtitleMessage",
            type: "text",
            label: "Subtitle Message",
            defaultValue: "",
            placeholder: "To your next chapter!",
            parentId: "titleMessage",
            required: false,
            min: 0,
            max: 30,
            preview: {
                sceneIndex: 0,
                frameOffset: 200,
            },
        },
    ],
    colorPalettes: ["MountainView"],
};
